<script>
export default{
    name: 'SettingsAccount',
    data(){
        return{
            notificationButtons:[
              {name: 'Delete Account', subtext: 'This will Delete all the data stored on your account and notify Developers that your data will be deleted in 30 days'},
              //{name: 'Example 1'},
              //{name: 'Example 2'},
            ]
        }
    }

}
</script>

<template>
  <section>
    <h4>Account</h4>
    <ul class="tabs-list">
      <li class="buttons" v-for="button in notificationButtons" :key="button.id">
        <input class="toggle" type="checkbox"></input>
        <span class="button-title">{{ button.name }}</span>
        <div class="button-subtext">{{ button.subtext }}</div>
      </li>
    </ul>
  </section>
</template>

<style scoped>
h4{
  color:#ff7222;
  justify-content: center;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #ff7222;
}
ul{
  all:unset;
}
.tabs-list{
  list-style: none;
}
.buttons{
  display:grid;
  grid-template:
  'toggle title' minmax(0.5rem, max-content)
  '.  subtxt' 
  ;
  grid-gap: 0 0.5rem;
  justify-content: start;
  margin-bottom: 1rem;
}
.toggle{
  grid-area: toggle;
  max-width: max-content;
  height: auto;
}
.button-title{
  grid-area: title;
  min-height: 0;
  height: 100%;
  align-content: center;
}
.button-subtext{
  font-size: small;
  color:#5b5b5b;
  grid-area: subtxt;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/SettingsTabs/Account.vue